import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
} from '@ionic/react';
import { useTranslation } from 'react-i18next';
import {
  IntercomArticle,
  useLaunchIntercomArticle,
} from '../../config/intercom';
import { RightAlignedButtons } from '../button/aligned-buttons';
import './feature-tour.css';

interface FeatureTourCardProps {
  title: string;
  content: string;
  intercomArticle: IntercomArticle;
  onStartTour: () => void;
}

const FeatureTourCard = (props: FeatureTourCardProps) => {
  const { title, content, intercomArticle, onStartTour } = props;

  const launchIntercomArticle = useLaunchIntercomArticle();
  const { i18n } = useTranslation();

  return (
    <IonCard className="feature-tour-card">
      <IonCardHeader>
        <IonCardTitle>{title}</IonCardTitle>
      </IonCardHeader>
      <IonCardContent>{content}</IonCardContent>
      <RightAlignedButtons>
        <IonButton
          onClick={() => {
            launchIntercomArticle(intercomArticle);
          }}
          fill="clear"
          color={'secondary'}
        >
          {i18n.t('common:learn_more')}
        </IonButton>
        <IonButton onClick={onStartTour} fill="clear">
          {i18n.t('common:start_tour')}
        </IonButton>
      </RightAlignedButtons>
    </IonCard>
  );
};

export { FeatureTourCard };
